import React from "react"
import * as styles from "./map-textbox.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';
import { useImage } from '../hooks/useImage'
import Text from './text'

export default function MapTextbox(props) {
    const image = useImage(props.image)
    return (
        <div className={styles.mapTextbox}>
            <h2 className={styles.headline} dangerouslySetInnerHTML={{__html: props.title}} ></h2>
            <Text className={styles.text} content={props.text} />
            {(image) && <div className={styles.imageContainer}><img className={styles.image} src={image.publicURL} /></div>}       
        </div>
    )
}